module.exports = __webpack_public_path__ + "static/img/jrwu.3592c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrwu.jpg
// module id = xXSa
// module chunks = 0